import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Routes from "./Routes";
import ErrorToast from "../../components/ErrorToast";
import { actions as appActions, getError } from "../../redux/modules/app";
import { get } from "../../utils/request";
import "./style.css";
class APP extends Component {
  constructor(props) {
    super(props);
    this.state = {
      css: {},
      show: 1,
    };
  }
  componentDidMount() {
    //console.log(JSON.parse(localStorage.getItem('schoolFilter')));
    localStorage.clear();
    this.fixCss();
    this.requestShow();
  }
  componentWillUnmount() {
    //window.removeEventListener("resize", this._resizeListener);
  }
  render() {
    const {
      error,
      appActions: { clearError },
    } = this.props;
    return (
      <div style={{ minHeight: this.state.css.minHeight }} className="app">
        <Routes></Routes>
        <div
          style={
            this.state.css.width > 750 && this.state.show === 1
              ? { display: "block" }
              : { display: "none" }
          }
        >
          <img
            style={{ position: "fixed", top: "250px", right: "0px" }}
            alt=""
            src={require("../../images/common/pc侧边2022.png")}
          ></img>
        </div>
        {error ? <ErrorToast msg={error} clearError={clearError} /> : null}
      </div>
    );
  }
  fixCss = () => {
    let minHeight = window.innerHeight;
    let width = window.innerWidth;
    this.setState({
      css: {
        minHeight: minHeight,
        width: width,
      },
    });
  };
  /**
   * 获取首页侧边栏的
   */
  requestShow = () => {
    get("/public/v1/sidebar/show").then((res) => {
      this.setState({
        show: res.data,
      });
    });
  };
}

const mapStateToProps = (state, props) => {
  return {
    error: getError(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    appActions: bindActionCreators(appActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(APP);



// WEBPACK FOOTER //
// ./src/containers/App/index.js